module.exports = {
  backOffice: {
    url: "/backoffice",
    apiName: "domcom_api_prod",
  },
};
